@use '@design/components/custom-scroll/custom-scroll' as *;

.tableScrollContainer {
  position: relative;
  overflow: auto;
  @include custom-scroll-minimal;
  flex: 1 1 0;
  min-height: 300px;

  :global([data-testid='no-results']) {
    margin-top: 24px;

    p:nth-of-type(2) {
      width: 420px;
      text-align: center;
    }
  }
}

.tableRoot {
  border-spacing: 0;
  width: 100%;

  --z-index-header-cell: 2;
  --z-index-table-cell: 1;

  tbody tr:hover {
    background-color: var(--surface-hover);

    td {
      background-color: var(--surface-hover);

      [aria-haspopup='true'] {
        border-bottom: 1px dashed var(--border-default);
      }
    }
  }
}

.tableHeader {
  position: sticky;
  top: 0;
  z-index: var(--z-index-app-header);
  cursor: pointer;
}

.footerRow {
  padding: 20px 0 0;
  border-bottom: none;
}

.rankWrapper {
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
}

.sectorName {
  font-family: var(--font-nort);
}
